import { useRef, useState } from "react";
import { cn } from "@/lib/utils";

export const TiltCard = ({ children, className, onClick, testid, maxTilt = 6 }) => {
    const ref = useRef(null);
    const [active, setActive] = useState(false);

    const move = (e) => {
        if (e.pointerType === "touch" || !ref.current) return;
        const r = ref.current.getBoundingClientRect();
        const x = (e.clientX - r.left) / r.width - 0.5;
        const y = (e.clientY - r.top) / r.height - 0.5;
        ref.current.style.transform =
            `perspective(900px) rotateX(${(-y * maxTilt).toFixed(2)}deg) rotateY(${(x * maxTilt).toFixed(2)}deg) translateY(-4px)`;
        setActive(true);
    };

    const leave = () => {
        if (ref.current) ref.current.style.transform = "";
        setActive(false);
    };

    return (
        <div
            ref={ref}
            onPointerMove={move}
            onPointerLeave={leave}
            onClick={onClick}
            data-testid={testid}
            data-active={active}
            role={onClick ? "button" : undefined}
            tabIndex={onClick ? 0 : undefined}
            onKeyDown={onClick ? (e) => { if (e.key === "Enter" || e.key === " ") { e.preventDefault(); onClick(e); } } : undefined}
            className={cn(
                "transition-[transform,box-shadow] duration-300 ease-out will-change-transform focus-visible:outline-2 focus-visible:outline-flame",
                onClick && "cursor-pointer",
                className
            )}
        >
            {children}
        </div>
    );
};
